
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

interface AdminPage {
  route: string;
  title: string;
}

/**
 * Einstieg in die internen Seiten. Sie sind absichtlich nicht im Kundenmenü verlinkt; diese Liste
 * ist der einzige Ort, an dem sie vollständig auftauchen.
 */
@Component({
  selector: 'app-energy-admin',
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './energy-admin.component.html',
})
export class EnergyAdminComponent {
  readonly pages: readonly AdminPage[] = [
    {
      route: 'location-settings',
      title: 'Anlage Einstellungen',
    },
    {
      route: 'price-debugger',
      title: 'Price Debugger',
    },
    {
      route: 'prices',
      title: 'Entso-E Price Import',
    },
    {
      route: 'optimizer',
      title: 'Optimierer starten',
    },
    {
      route: 'forecast-and-optimizer',
      title: 'Forecast- und Optimierer Schnittstelle',
    },
    {
      route: 'energy-chart-debug',
      title: 'Energy Chart Debug',
    },
    {
      route: 'energy-balance-debug',
      title: 'Energy Balance Debug',
    },
    {
      route: 'chart-comparison-debug',
      title: 'Chart Comparison Debug',
    },
    {
      route: 'schedule',
      title: 'Fahrplan senden',
    },
  ];
}
